<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>
    <app-document-list :documents="documents"></app-document-list>

    <div class="row">
      <div class="col-sm load-more">
        <button v-show="hasMore && !loading" class="btn btn-feedback btn-outline" @click="loadMore">Загрузить ещё</button>
        <app-spinner v-show="loading"></app-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { AppPageSearch, AppSpinner, AppDocumentList } from "@/components";
import { loadDocuments, loadDocument } from "@/api/regulations";

export default {
  name: "Regulations",
  components: {
    AppPageSearch,
    AppSpinner,
    AppDocumentList
  },

  data: () => ({
    documents: [],
    totalCount: "",
    loading: true,
    title: "Разделы",
    itemsPerPage: 8,
    page: 1
  }),

  computed: {
    hasMore() {
      return this.documents.length < this.totalCount;
    }
  },
  watch: {
    async $route() {
      if (this.$route.query.docId) {
        const document = await loadDocument(this.$route.query.docId);
        this.documents = [document];
        this.totalCount = 1;
      } else {
        this.documents = [];
        this.loadDocuments({ page: this.page, per_page: this.itemsPerPage });
      }
    }
  },

  async created() {
    if (this.$route.query.docId) {
      const document = await loadDocument(this.$route.query.docId);
      this.documents = [document];
      this.loading = false;
    } else {
      this.loadDocuments({ page: this.page, per_page: this.itemsPerPage });
    }
  },

  methods: {
    loadMore() {
      this.page += 1;
      this.loadDocuments({ page: this.page, per_page: this.itemsPerPage });
    },

    async loadDocuments(params) {
      this.loading = true;

      const response = await loadDocuments(params);
      this.documents = this.documents.concat(response.data);
      this.totalCount = response.meta.pagination.total;

      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
